export default __webpack_public_path__ + "static/media/win.b0e31f3d.png";